import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { AppProvider, Frame, Toast } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';

// import { AdminProvider } from "context/admin";
import { useUser } from "context/user";
import { useAdmin } from "context/admin";

import DashboardSidebar from "./DashboardSidebar";
import DashboardTopBar from "./DashboardTopBar";
// import LoadingPage from "shared/LoadingPage";
import AdminPages from "views/AdminPages/AdminPages";
import ComingSoonPage from "views/Pages/ComingSoonPage";
import ErrorPage from "views/Pages/ErrorPage";
import ShopsPage from "views/ShopsPage/ShopsPage";
import ConfirmModal from './ConfirmModal';

const NAV_COLLAPSED_BREAKPOINT = 768;

export default function Dashboard() {
  const { toast, setToast, confirmation, setConfirmation } = useAdmin();
  const user = useUser();

  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const openMobileNavigation = () => setMobileNavigationActive(true);
  const closeMobileNavigation = () => setMobileNavigationActive(false);

  // Reset mobile nav when viewport is wide (prevents Backdrop blocking clicks on desktop)
  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${NAV_COLLAPSED_BREAKPOINT + 1}px)`);
    const handler = () => { if (mql.matches) setMobileNavigationActive(false); };
    mql.addEventListener('change', handler);
    handler();
    return () => mql.removeEventListener('change', handler);
  }, []);

  const toastMarkup = toast ? (
    <Toast
      content={toast}
      onDismiss={() => setToast()}
      // Long messages (e.g. CLV-4 overage invoice notices) need time to be read.
      duration={typeof toast === "string" && toast.length > 80 ? 15000 : undefined}
    />
  ) : null;

  const confirmationMarkup = confirmation ?
    <ConfirmModal
      open={true}
      handleClose={() => setConfirmation(null)}
      {...confirmation}
    /> : null;


  return (
    <AppProvider
      i18n={translations}>
      <Frame
        showMobileNavigation={mobileNavigationActive}
        onNavigationDismiss={closeMobileNavigation}
        navigation={<DashboardSidebar onNavigationDismiss={closeMobileNavigation} />}>
        <DashboardTopBar handleMobileNavigation={openMobileNavigation}/>

        <Switch>
          { user && user.isAdmin ? <Route path="/admin" component={AdminPages}  /> : '' }
          <Route exact path="/coming-soon" component={ComingSoonPage} />

          {/* Shop Routes */}
          <Route path="/shops" component={ShopsPage} />

          <Redirect to="/shops" />
          <Route component={ErrorPage} />

        </Switch>
        {toastMarkup}
        {confirmationMarkup}
      </Frame>
    </AppProvider>
  );
}
